export enum PaymentTabsEnum {
    CreditCard = 1,
    PayPal = 2,
    AliPay = 3,
    ApplePay = 4,
}